package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.Accent
import com.merkost.handpass.sharedweb.theme.OnAccent
import com.merkost.handpass.sharedweb.theme.RadiusFull
import com.merkost.handpass.sharedweb.theme.WebAvatarMetrics
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

val WebAvatarStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
        .justifyContent(JustifyContent.Center)
        .borderRadius(RadiusFull.value())
        .backgroundColor(Accent.value())
        .color(OnAccent.value())
        .fontWeight(700)
        .styleModifier {
            property("overflow", "hidden")
            property("flex-shrink", "0")
        }
}

@Composable
fun WebAvatar(
    name: String?,
    url: String?,
    size: Int = WebAvatarMetrics.DefaultSize,
    fontPx: Int = WebAvatarMetrics.DefaultFont,
) {
    Div(
        attrs = WebAvatarStyle.toModifier()
            .width(size.px)
            .height(size.px)
            .styleModifier { property("font-size", "${fontPx}px") }
            .toAttrs()
    ) {
        if (url != null) {
            Img(
                src = url,
                alt = name?.let { "$it profile photo" } ?: "Profile photo",
                attrs = {
                    style {
                        width(100.percent)
                        height(100.percent)
                        property("object-fit", "cover")
                    }
                },
            )
        } else {
            Text(avatarInitials(name))
        }
    }
}

private fun avatarInitials(name: String?): String {
    val parts = name?.trim()?.split(Regex("\\s+"))?.filter { it.isNotEmpty() }.orEmpty()
    return when {
        parts.isEmpty() -> "?"
        parts.size == 1 -> parts[0].take(2).uppercase()
        else -> "${parts.first().first()}${parts.last().first()}".uppercase()
    }
}
